import * as Tools from "../../helpers/Tools";
import { logUI } from "../../api/andyliticsApi";
import { Grid } from "../ecosystem";
import { LandingCard, PageHeading } from "../ecosystem/mybswh";

const RecordsMedicalFormsLanding = (props) => {

    logUI("MBHWeb.UI.RecordsMedicalForms.ComponentDidMount", new Date(), Tools.getURLPath());

    const onClickTile = (tileName, routeName) => {
        logUI(`MBHWeb.UI.RecordsMedicalFormsLanding.${tileName}.Clicked`, new Date(), Tools.getURLPath());
        if (routeName) {
            props.history.push(routeName);
        }
    };

    const headingText = "Records & Medical Forms"

    const { isMyChartUser, disableMyChartMenuItems } = Tools.handleMychartUserShowOrHideMenuItems();
    const { proxyName } = Tools.getProxyName();

    const landingItems = [
        {
            title: "Document Center",
            body: "View, download, or send a copy of specific visit summaries.",
            to: "/medicalrecord",
            show: isMyChartUser,
            disabled: disableMyChartMenuItems,
            onClick: () => { onClickTile("DocumentCenter"); }
        },
        {
            title: "Who’s Accessed My Profile?",
            body: "View users or third party apps who have accessed your medical record.",
            to: "/audit",
            show: isMyChartUser,
            disabled: disableMyChartMenuItems,
            onClick: () => { onClickTile("WhosAccessedMyProfile"); }
        },
        {
            title: "Growth Charts",
            body: "Track your children's growth and compare to others in their age group.",
            to: "/growthcharts",
            show: isMyChartUser,
            disabled: disableMyChartMenuItems,
            onClick: () => { onClickTile("GrowthCharts"); }
        },
        {
            title: "Questionnaires",
            body: "Provide general and family history information and respond to other questions from your healthcare provider.",
            to: "/questionnaires",
            show: isMyChartUser,
            disabled: disableMyChartMenuItems,
            onClick: () => { onClickTile("DocumentCenter"); }
        },
        {
            title: "Share My Record",
            body: <span>Grant one-time, limited access to the health information you see in MyBSWHealth with <b>‘Share Everywhere®’</b></span>,
            to: "/shareeverywhere",
            show: isMyChartUser,
            disabled: disableMyChartMenuItems,
            onClick: () => { onClickTile("ShareMyRecord"); }
        }
    ]

    return (
        <Grid className="body-content body-content--no-top-offset body-content--bg-gray recordsmedicalforms-landing-container">
            <div className="row">
                <div className="col-12 maxWidth-content">
                    <PageHeading bodyOffset heading={headingText} proxyName={proxyName} />
                    <div className="row">
                        {
                            landingItems.map((item, i) => {
                                return item.show ? (
                                    <div className="col-12 col-lg-6">
                                        <LandingCard {...item} />
                                    </div>
                                ) : null
                            })
                        }
                    </div>
                </div>
            </div>
        </Grid>
    )
}

export default RecordsMedicalFormsLanding;